import React, { useEffect } from "react";
import Wheel from "./Wheel";
import ProgressBar from "./ProgressBar";

const Main = ({
  members,
  onSelectMember,
  categoryList,
  wheel,
  isOpenQuestion,
  totalRound,
  currentRound,
  currentTime,
  isMaxAlert,
  result,
  isActive
}) => {
  const classActive = isActive ? "is-active" : "";
  return (
    <div className={`main ${classActive}`}>
      <div className="container main-container">
        <div className="main-body">
          <Wheel
            result={result}
            members={members}
            onSelectedPlayer={onSelectMember}
            data={categoryList}
            {...wheel}
            isOpenQuestion={isOpenQuestion}
            currentRound={currentRound}
            currentTime={currentTime}
            totalRound={totalRound}
            isMaxAlert={isMaxAlert}
          />
          <ProgressBar
            currentRound={currentRound}
            totalRound={totalRound}
            isDisplayContent={true}
          />
        </div>
      </div>
    </div>
  );
};

export default Main;
